import { FC } from 'react';
import { TextProps, Text } from '@weave/design-system';
import { SalesforceQueries } from '../../apis/salesforce';

export const ContractedBundleName: FC<TextProps & { locationId: string }> = ({
  locationId,
  ...textProps
}) => {
  const { data: bundleName, isLoading } = SalesforceQueries.useGetSalesforceBundleName(
    {
      locationId,
    },
    {
      select: (response) => response.bundleDisplayName,
    }
  );
  return (
    <Text as="span" size="medium" {...textProps}>
      {isLoading ? 'Loading...' : bundleName || 'Unknown'}
    </Text>
  );
};
